function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon as FabricIcon } from '@fluentui/react';
import * as React from 'react';
/**
 * @deprecated Komponenten er erstattet av Icon fra "@skatteetaten/ds-icons"
 *
 * visibleName Icon (Ikon)
 */

export const Icon = props => {
  const {
    className
  } = props,
        rest = _objectWithoutProperties(props, ["className"]);

  return /*#__PURE__*/React.createElement(FabricIcon, _extends({}, rest, {
    className: className
  }));
};
Icon.defaultProps = {
  iconName: undefined,
  imageProps: undefined
};